<template>
  <div class="top-card">
    <div class="tip"  v-if="$store.state.plat_id!='120'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 1是  2不是-->
            <img :src="$free" v-if="cardData.is_free==1"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <img class="top-cover" :src="cardData.master_cover" alt="" />
    <div class="top-msg">
      <div class="top-name ellipsis_two">{{ cardData.name }}</div>
      <div class="top-num">{{ cardData.ordernum }}人已学习</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.top-card {
  display: inline-block;
  width: 230px;
  height: 380px;
  margin-right: 20px;
  position: relative;
  .tip{
    position: absolute;
    top:0;
    left:0px;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}

.top-cover {
  width: 230px;
  height: 240px;
  border-radius: 12px;
  display: block;
}

.top-msg {
  height: 140px;
  width: 230px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  padding: 10px 0;
  box-sizing: border-box;
}

.top-name {
  font-size: 28px;
  color: #555;
  font-weight: 600;
  line-height: 38px;
  width: 100%;
}

.top-num {
  font-size: 24px;
  color: #555;
  font-weight: 400;
  line-height: 33px;
}
</style>>
